// Shared by the landing hero and the quote wizard backdrop so both feel like the same space.
const HERO_BASE = 'https://casa-aragon-docs.sfo3.cdn.digitaloceanspaces.com/images/hero/sylvia-camilo';
// The photo always covers the full viewport width: object-cover on a 3:2 image means portrait screens size it by height
export const HERO_IMAGE_SIZES = 'max(100vw, 150vh)';
const HERO_WIDTHS = [800, 1200, 2400] as const;
const heroSrcSet = (ext: 'avif' | 'webp' | 'jpg') =>
  HERO_WIDTHS.map((width) => `${HERO_BASE}-${width}.${ext} ${width}w`).join(', ');

export const HERO_IMAGE_URL = `${HERO_BASE}-2400.jpg`;
// AVIF and WebP are the real payload for modern browsers; JPEG is the universal fallback
export const HERO_IMAGE_SRCSET_AVIF = heroSrcSet('avif');
export const HERO_IMAGE_SRCSET_WEBP = heroSrcSet('webp');
export const HERO_IMAGE_SRCSET = heroSrcSet('jpg');
export const HERO_IMAGE_ALT = 'Pareja besándose bajo glicinas colgantes - Bodas Casa Aragón';

// Mi boda banner: a band of the ceremony photo (rows 290–710 of 1600×1067), cropped by Cloudinary. Cloudinary sends
// CORS headers, so the wind sway's WebGL can read the same image the <img> shows. Keep the crop in sync with
// BAND_TOP / BAND_H in scripts/hero-motion/make_ceremony_assets.py (the sway mask is cut from that band).
const CEREMONY_PHOTO = 'v1792030546/casa-aragon/hero/ceremonia-mg-9013.jpg';
const ceremonyBand = (width?: number) =>
  `https://res.cloudinary.com/dwqywcwtj/image/upload/c_crop,x_0,y_290,w_1600,h_420/${width ? `w_${width}/` : ''}f_auto,q_auto/${CEREMONY_PHOTO}`;
export const CEREMONY_BAND_URL = ceremonyBand();
export const CEREMONY_BAND_URL_800 = ceremonyBand(800);
export const CEREMONY_BAND_SRCSET = `${CEREMONY_BAND_URL_800} 800w, ${CEREMONY_BAND_URL} 1600w`;

// Mi boda banner: the Salón del Bosque at night (chandeliers, drapes, greenery), a band of rows 250–670 of 1536×1024,
// cropped by Cloudinary (CORS-enabled, so the sway's WebGL can read it). Keep the crop in sync with BAND_TOP / BAND_H in
// scripts/hero-motion/make_salon_assets.py (the sway mask is cut from that band).
const SALON_PHOTO = 'v1792086586/casa-aragon/hero/salon-del-bosque-noche.png';
const salonBand = (width?: number) =>
  `https://res.cloudinary.com/dwqywcwtj/image/upload/c_crop,x_0,y_250,w_1536,h_420/${width ? `w_${width}/` : ''}f_auto,q_auto/${SALON_PHOTO}`;
export const SALON_BAND_URL = salonBand();
export const SALON_BAND_URL_800 = salonBand(800);
export const SALON_BAND_SRCSET = `${SALON_BAND_URL_800} 800w, ${SALON_BAND_URL} 1536w`;

// Trimmed to the visible mark (822×350, no transparent padding), so its box is the mark: sizes and alignment are exact.
// The padded 1000px original stays on the CDN for places that rely on its margins.
export const PRIMARY_LOGO_URL =
  'https://casa-aragon-docs.sfo3.cdn.digitaloceanspaces.com/images/branding/logos/primary/trimmed/logo-principal-trimmed-822px.png';
